import { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const faqsLeft = [
  {
    question: "What is the Certificate Course in Regulatory License and Compliance?",
    answer: "This course is a specialized professional program designed to equip participants with in-depth knowledge of business setup, licensing, regulatory procedures, and compliance requirements in Bangladesh. It helps entrepreneurs, consultants, and professionals confidently navigate business laws and government regulations."
  },
  {
    question: "Who should enroll in this course?",
    answer: "This program is ideal for:\n• Aspiring business consultants\n• Entrepreneurs planning to start a company or NGO\n• Corporate professionals involved in compliance or legal affairs\n• Students of business, law, or management seeking career advancement"
  },
  {
    question: "What topics are covered in the course?",
    answer: "The course covers a comprehensive range of modules, including:\n• Introduction to License and Compliance\n• Requirements for Local Company Formation in Bangladesh\n• Foundation & NGO Registration Process\n• Foreign Company Setup, BIDA Registration, Work Permits & Visas\n• Intellectual Property (Trademark, Copyright, Patent) Registration\n• Taxation and Compliance\n• Special Class – Practical Case Studies & Industry Insights\n(Note: Digital Marketing & Customer Acquisition module has been discontinued.)"
  },
  {
    question: "What will I learn from this course?",
    answer: "By completing this program, you will gain:\n• A clear understanding of all legal and compliance frameworks in Bangladesh\n• Practical knowledge of registration procedures for companies and NGOs\n• The ability to advise clients on regulatory matters confidently\n• Insights into intellectual property protection and tax compliance\n• A strong foundation to start or grow a career in consultancy or corporate compliance"
  },
];

const faqsRight = [
  {
    question: "Will I receive a certificate after completion?",
    answer: "Yes! Upon successful completion, participants will receive a joint certificate from JK Associates & Chartered Skills, officially recognizing their expertise in regulatory license and compliance — a valuable credential for both career and consultancy practice."
  },
  {
    question: "How long is the course and how are the classes conducted?",
    answer: "The course duration and schedule are designed to suit working professionals and students, with flexible practical classes led by experienced industry mentors. Each module includes interactive discussions, case studies, and real-world documentation practice."
  },
  {
    question: "Are the instructors experienced in this field?",
    answer: "Absolutely! All trainers are experienced business consultants, legal advisors, and regulatory experts with hands-on knowledge of Bangladesh’s business and compliance environment."
  },
  {
    question: "How can I enroll?",
    answer: "You can easily enroll by visiting our JK Associates office or contacting us through our official website or social media channels. Our team will guide you through the registration and course details."
  },
  {
    question: "Why choose this course from JK Associates?",
    answer: "Because JK Associates brings real-world consultancy expertise directly into the classroom. With our blend of practical training, legal insight, and certification, this course gives you the tools to launch your consultancy career or strengthen your professional credentials in compliance and business advisory."
  },
];

const FAQSectionBusiness = () => {
  const [openLeft, setOpenLeft] = useState(null);
  const [openRight, setOpenRight] = useState(null);

  const faqStyle = (isOpen) => ({
    backgroundColor: isOpen ? "#0d6efd" : "#fff",
    color: isOpen ? "#fff" : "#333",
    borderRadius: "12px",
    padding: "18px 22px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "all 0.3s",
    whiteSpace: "pre-line",
  });

  const answerStyle = {
    marginTop: "10px",
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#fff",
    whiteSpace: "pre-line",
  };

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "40px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px" }}>Frequently Asked Questions</h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Answers to the most common questions about the Certificate Course in Regulatory License and Compliance.
        </p>
      </div>

      <div style={{ display: "flex", gap: "20px", flexWrap: "wrap" }}>
        {/* Left FAQs */}
        <div style={{ flex: "1", minWidth: "300px", display: "flex", flexDirection: "column", gap: "15px" }}>
          {faqsLeft.map((faq, index) => {
            const isOpen = openLeft === index;
            return (
              <div
                key={index}
                style={faqStyle(isOpen)}
                onClick={() => setOpenLeft(isOpen ? null : index)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                  {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isOpen && <p style={answerStyle}>{faq.answer}</p>}
              </div>
            );
          })}
        </div>

        {/* Right FAQs */}
        <div style={{ flex: "1", minWidth: "300px", display: "flex", flexDirection: "column", gap: "15px" }}>
          {faqsRight.map((faq, index) => {
            const isOpen = openRight === index;
            return (
              <div
                key={index}
                style={faqStyle(isOpen)}
                onClick={() => setOpenRight(isOpen ? null : index)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>{faq.question}</span>
                  {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                {isOpen && <p style={answerStyle}>{faq.answer}</p>}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSectionBusiness;
